import { sellerService } from '@/services/seller';
import { subtractHours, isValidTimeRange } from './discount-time';

/**
 * 시간을 분 단위로 변환하여 비교하는 함수
 * @param time1 - 첫 번째 시간 ("HH:MM")
 * @param time2 - 두 번째 시간 ("HH:MM")
 * @returns time1 - time2 (분 단위)
 */
function compareTime(time1: string, time2: string): number {
  const [h1, m1] = time1.split(':').map(Number);
  const [h2, m2] = time2.split(':').map(Number);
  return (h1 * 60 + m1) - (h2 * 60 + m2);
}

/**
 * 영업시간 기반으로 마감할인 수령시간 기본값을 계산합니다
 * @param restaurantId - 레스토랑 ID
 * @returns 수령시간 기본값 { start, end }
 */
export async function calculateDefaultPickupTimes(restaurantId: string): Promise<{
  start: string;
  end: string;
}> {
  try {
    const result = await sellerService.getOperatingHours(restaurantId);
    
    if (result.success && result.data) {
      // 오늘 요일 가져오기 (일요일 = 0)
      const today = new Date().getDay();
      const todayHours = result.data[today];
      
      if (todayHours && !todayHours.isClosed && todayHours.closeTime) {
        // 영업종료 - 2시간을 수령시작 시간으로 설정
        const pickupEnd = todayHours.closeTime;
        const pickupStart = subtractHours(pickupEnd, 2);
        
        // 영업시간이 2시간 미만인 경우 전체 영업시간 사용
        let finalStart = pickupStart;
        let finalEnd = pickupEnd;
        
        // pickupStart가 영업시작시간보다 이른 경우 영업시작시간으로 조정
        if (todayHours.openTime && compareTime(pickupStart, todayHours.openTime) < 0) {
          finalStart = todayHours.openTime;
        }
        
        // 최종 검증: 시작 시간이 종료 시간보다 늦거나 같으면 fallback
        if (!isValidTimeRange(finalStart, finalEnd) || compareTime(finalStart, finalEnd) >= 0) {
          console.warn('Invalid time range calculated:', { start: finalStart, end: finalEnd });
          // 영업시간이 2시간 미만인 경우, 전체 영업시간을 사용
          if (todayHours.openTime && todayHours.closeTime && isValidTimeRange(todayHours.openTime, todayHours.closeTime)) {
            return {
              start: todayHours.openTime,
              end: todayHours.closeTime
            };
          }
          return { start: '18:00', end: '20:00' };
        }
        
        return {
          start: finalStart,
          end: finalEnd
        };
      }
    }
  } catch (error) {
    console.error('Failed to calculate default pickup times:', error);
  }
  
  // 기본값 fallback
  return {
    start: '18:00',
    end: '20:00'
  };
}